import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Text from '../../../Text'

function SideTextBlocks({ textBlocks }) {
  return (
    <div className={styles.textBlocksWrapper}>
      {
        textBlocks.map(block => (
          <div className={styles.textBlock} key={block._key}>
            <div className={styles.titleWrapper}>
              <Text type="h4">{block.title}</Text>
            </div>
            <div className={styles.textWrapper}>
              <SimpleBlockContent blocks={block.text} noSpace/>
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default SideTextBlocks
